<cc-data-grid-features
    [stateConfig]="{ storageKey: storageKey, storeGroupings: true }"
    [dataSource]="workOrdersGridSource"
>
    <dx-data-grid
        #workOrderGrid
        appHasInternalUserColumns
        appHasRestrictedColumns
        width="100%"
        height="100%"
        keyExpr="workOrderId"
        [dataSource]="workOrdersGridSource"
        (onContentReady)="onGridContentReady()"
        (onSelectionChanged)="onRowSelection($event)"
    >
        <ng-container *ngIf="isPopup">
            <dxo-selection showCheckBoxesMode="always" mode="multiple"></dxo-selection>
        </ng-container>
        <dxo-grouping [autoExpandAll]="false"></dxo-grouping>
        <dxi-column
            name="InternalActions"
            caption="Action"
            cellTemplate="actionButtonTemplate"
            alignment="center"
            type="buttons"
            [width]="110"
            [visibleIndex]="0"
            [visible]="!isPopup"
            [showInColumnChooser]="!isPopup"
        ></dxi-column>

        <dxi-column
            dataField="location"
            dataType="string"
            caption="Location"
            [visible]="!isPopup"
            [showInColumnChooser]="!isPopup"
        ></dxi-column>
        <dxi-column
            dataField="community"
            dataType="string"
            caption="Community"
            [visible]="!isPopup"
            [showInColumnChooser]="!isPopup"
            cellTemplate="communityCellTemplate"
        ></dxi-column>
        <dxi-column
            dataField="maintenanceJob"
            dataType="number"
            caption="Maintenance Job #"
            [visible]="!isPopup"
            [showInColumnChooser]="!isPopup"
            cellTemplate="maintenanceJobTemplate"
        ></dxi-column>
        <dxi-column
            dataField="workOrderId"
            dataType="number"
            caption="Work Order #"
            cellTemplate="workOrderCellTemplate"
        ></dxi-column>
        <dxi-column
            name="RestrictedColumn|PROJECTS_TASKS"
            dataField="taskIdText"
            dataType="string"
            caption="Tasks"
            alignment="right"
            cellTemplate="taskListTemplate"
            [visible]="!isPopup"
            [showInColumnChooser]="!isPopup"
        >
            <dxo-header-filter [dataSource]="uniqueTaskIds"></dxo-header-filter>
        </dxi-column>
        <dxi-column
            name="RestrictedColumn|SEARCH_INVOICES"
            dataField="invoiceIdText"
            dataType="string"
            caption="Invoices"
            alignment="right"
            cellTemplate="invoiceListTemplate"
            [visible]="!isPopup"
            [showInColumnChooser]="!isPopup"
        >
            <dxo-header-filter [dataSource]="uniqueInvoiceIds"></dxo-header-filter>
        </dxi-column>
        <dxi-column
            dataField="jobType"
            dataType="string"
            caption="Job Type"
            [visible]="!isPopup"
            [showInColumnChooser]="!isPopup"
        ></dxi-column>
        <dxi-column dataField="status" dataType="string" caption="Status"></dxi-column>
        <dxi-column
            dataField="priority"
            dataType="string"
            caption="Priority"
            [visible]="!isPopup"
            [showInColumnChooser]="!isPopup"
        ></dxi-column>
        <dxi-column
            dataField="vendor"
            dataType="string"
            caption="Vendor"
            cellTemplate="vendorCellTemplate"
            [visible]="!isPopup"
            [showInColumnChooser]="!isPopup"
        ></dxi-column>
        <dxi-column
            dataField="referenceType"
            dataType="string"
            caption="Reference Type"
            [visible]="!isPopup"
            [showInColumnChooser]="!isPopup"
        ></dxi-column>
        <dxi-column
            dataField="reference"
            dataType="string"
            caption="Reference"
            cellTemplate="referenceTemplate"
        ></dxi-column>
        <dxi-column
            dataField="createDate"
            dataType="date"
            caption="Created"
            [format]="dateFormat"
            [visible]="!isPopup"
            [showInColumnChooser]="!isPopup"
        ></dxi-column>
        <dxi-column
            caption="Responsible"
            dataType="string"
            dataField="responsibleUserDisplayText"
            cellTemplate="responsibleUserDisplayTemplate"
            [allowGrouping]="false"
        ></dxi-column>
        <dxi-column
            dataField="dueDate"
            dataType="date"
            caption="Due"
            [format]="dateFormat"
            [visible]="!isPopup"
            [showInColumnChooser]="!isPopup"
        ></dxi-column>
        <dxi-column
            dataField="authorizationAmount"
            dataType="number"
            caption="Authorization Amount"
            [format]="currencyFormat"
            [allowGrouping]="false"
            [visible]="!isPopup"
            [showInColumnChooser]="!isPopup"
        ></dxi-column>
        <dxi-column
            name="InternalNotes"
            caption="Notes"
            dataField="hasNotes"
            dataType="boolean"
            headerCellTemplate="lockHeaderCellTemplate"
            cellTemplate="notesCellTemplate"
            alignment="center"
            [allowGrouping]="false"
            [visible]="!isPopup"
            [showInColumnChooser]="!isPopup"
        ></dxi-column>
        <dxi-column
            name="InternalLogs"
            caption="Log"
            headerCellTemplate="lockHeaderCellTemplate"
            cellTemplate="historyCellTemplate"
            alignment="center"
            [allowGrouping]="false"
            [visible]="!isPopup"
            [showInColumnChooser]="!isPopup"
        ></dxi-column>
        <dxi-column
            dataType="number"
            dataField="attachmentCount"
            caption=""
            cellTemplate="attachmentCellTemplate"
            alignment="center"
            [allowGrouping]="false"
            [visible]="!isPopup"
            [showInColumnChooser]="!isPopup"
        ></dxi-column>
        <dxi-column
            dataField="communityCode"
            dataType="string"
            caption="Community ID"
            cellTemplate="communityCellTemplate"
            [visible]="false"
            [visible]="!isPopup"
            [showInColumnChooser]="!isPopup"
        ></dxi-column>
        <dxi-column
            dataField="createdByUserDisplayText"
            dataType="string"
            caption="Created By"
            cellTemplate="createdByUserDisplayTemplate"
            [visible]="false"
            [visible]="!isPopup"
            [showInColumnChooser]="!isPopup"
        ></dxi-column>
        <dxi-column
            caption="Dashboard Responsible"
            dataType="string"
            dataField="dashboardResponsibleUserDisplayText"
            cellTemplate="dashboardResponsibleUserTemplate"
            [allowGrouping]="false"
            [visible]="false"
            [visible]="!isPopup"
            [showInColumnChooser]="!isPopup"
        >
            <dxo-header-filter [dataSource]="uniqueDashboardResponsibleUsers"></dxo-header-filter>
        </dxi-column>
        <dxi-column
            dataField="ownerName"
            dataType="string"
            caption="Owner Name"
            cellTemplate="referenceTemplate"
            [visible]="false"
            [visible]="!isPopup"
            [showInColumnChooser]="!isPopup"
        ></dxi-column>
        <dxi-column
            dataField="ownerPhone"
            dataType="string"
            caption="Owner Phone"
            [visible]="false"
            [visible]="!isPopup"
            [showInColumnChooser]="!isPopup"
        ></dxi-column>
        <dxi-column
            dataField="caller"
            dataType="string"
            caption="Caller"
            [visible]="false"
            [visible]="!isPopup"
            [showInColumnChooser]="!isPopup"
        ></dxi-column>
        <dxi-column dataField="description" dataType="string" caption="Description" [visible]="isPopup"></dxi-column>
        <dxi-column
            dataField="primaryAcamDisplayText"
            dataType="string"
            caption="Primary ACAM"
            cellTemplate="primaryAcamUserDisplayTemplate"
            [visible]="false"
            [showInColumnChooser]="!isPopup"
        >
            <dxo-header-filter [dataSource]="uniquePrimaryAcamUsers"></dxo-header-filter>
        </dxi-column>
        <dxi-column
            dataField="primaryCamDisplayText"
            dataType="string"
            caption="Primary CAM"
            cellTemplate="primaryCamUserDisplayTemplate"
            [visible]="false"
            [showInColumnChooser]="!isPopup"
        >
            <dxo-header-filter [dataSource]="uniquePrimaryCamUsers"></dxo-header-filter>
        </dxi-column>
        <dxi-column
            dataField="statusChanged"
            dataType="date"
            caption="Status Changed"
            [format]="dateFormat"
            [visible]="false"
            [showInColumnChooser]="!isPopup"
        ></dxi-column>
        <dxi-column
            dataField="statusChangedByDisplayText"
            dataType="string"
            caption="Status Changed By"
            cellTemplate="statusChangedByUserDisplayTemplate"
            [visible]="false"
            [showInColumnChooser]="!isPopup"
        ></dxi-column>
        <dxi-column
            name="InternalDashboardStatus"
            dataType="string"
            dataField="dashboardStatusDisplayText"
            caption="Dashboard Status"
            headerCellTemplate="lockHeaderCellTemplate"
            cellTemplate="dashboardStatusCellTemplate"
            alignment="center"
            [visible]="false"
            [showInColumnChooser]="!isPopup"
        ></dxi-column>
        <dxi-column
            dataField="vendorEstimate"
            dataType="number"
            caption="Vendor Estimate"
            [format]="currencyFormat"
            [allowGrouping]="false"
            [visible]="false"
            [showInColumnChooser]="!isPopup"
        ></dxi-column>

        <dxo-master-detail [enabled]="true" template="detail"></dxo-master-detail>

        <div *dxTemplate="let row of 'detail'">
            {{ row.data.description }}
        </div>

        <div *dxTemplate="let d of 'attachmentCellTemplate'">
            <div class="row-container">
                <i
                    class="cc-1-5x dx-theme-accent-as-text-color cell-link-content add-short-padding"
                    [ngClass]="iconAttachment"
                    (click)="onAttachmentClick(d.data)"
                ></i>
                <ng-container *ngIf="d.data.attachmentCount > 0">({{ d.data.attachmentCount }})</ng-container>
                <ng-container *ngIf="d.data.attachmentCount === 0"><div class="add-padding"></div></ng-container>
            </div>
        </div>

        <div *dxTemplate="let d of 'notesCellTemplate'" (click)="onGridNotesClick(d.data)">
            <div *ngIf="d.data.hasNotes">
                <i
                    class="cc-1-5x cell-link-content cc-icon-content cc-icon-check"
                    title="Internal Notes"
                    [ngClass]="iconNotes"
                ></i>
            </div>

            <div *ngIf="!d.data.hasNotes">
                <i
                    class="cc-1-5x cell-link-content dx-theme-accent-as-text-color"
                    title="Internal Notes"
                    [ngClass]="iconEmptyNotes"
                ></i>
            </div>
        </div>

        <div *dxTemplate="let t of 'historyCellTemplate'">
            <i
                class="cc-1-5x cell-link-content dx-theme-accent-as-text-color"
                title="Logs"
                [ngClass]="iconHistory"
                (click)="onHistoryClick(t.data)"
            ></i>
        </div>

        <div *dxTemplate="let cell of 'dashboardStatusCellTemplate'">
            <div *ngIf="!!cell.data.dashboardProblematic">
                <i class="cc-1-5x cc-red-icon" title="Problematic" [ngClass]="iconFlag"></i>
            </div>

            <div *ngIf="!cell.data.dashboardProblematic && !!cell.data.dashboardPriority">
                <i class="cc-1-5x cc-icon-ppt" title="Priority" [ngClass]="iconAlert"></i>
            </div>
        </div>

        <div *dxTemplate="let t of 'actionButtonTemplate'">
            <app-grid-actions-menu
                [actionMenuItems]="actionMenuItems"
                [record]="t.data"
                [rowIndex]="t.rowIndex"
                [isActionVisible]="isActionItemVisible"
                (onActionClick)="onActionItemClick($event)"
            ></app-grid-actions-menu>
        </div>

        <div *dxTemplate="let row of 'vendorCellTemplate'">
            <ng-container *ngIf="!!row.data.vendorCode">
                <app-hyperlink-creator
                    actionCode="VENDOR_MANAGEMENT"
                    [displayText]="row.data.vendor"
                    [communityId]="row.data.communityId"
                    (onLinkClick)="onVendorNameClick(row.data)"
                ></app-hyperlink-creator>
            </ng-container>
            <ng-container *ngIf="!row.data.vendorCode">
                {{ row.data.vendor }}
            </ng-container>
        </div>

        <div *dxTemplate="let cell of 'communityCellTemplate'">
            <app-property-community-link
                [communityId]="cell.data.communityId"
                [displayText]="cell.value"
            ></app-property-community-link>
        </div>

        <div *dxTemplate="let cell of 'referenceTemplate'">
            <ng-container *ngIf="cell.data.referenceType === 'Property'">
                <app-property-community-link
                    [communityId]="cell.data.communityId"
                    [customerId]="cell.data.customerId"
                    [displayText]="cell.value"
                ></app-property-community-link>
            </ng-container>
            <ng-container *ngIf="cell.data.referenceType !== 'Property'">
                {{ cell.value }}
            </ng-container>
        </div>

        <div *dxTemplate="let cell of 'workOrderCellTemplate'">
            <ng-container *ngIf="!isPopup">
                <app-hyperlink-creator
                    *ngIf="cell.data.workAuthorizationFileStoreId"
                    cssClass="cc-hyperlink-underline-hover"
                    mode="hyperlinkOnly"
                    [displayText]="cell.data.workOrderId"
                    (onLinkClick)="onWorkOrderCellClick(cell.data)"
                ></app-hyperlink-creator>
                <ng-container *ngIf="!cell.data.workAuthorizationFileStoreId">
                    {{ cell.data.workOrderId }}
                </ng-container>
            </ng-container>
            <ng-container *ngIf="isPopup">
                <app-hyperlink-creator
                    mode="hyperlinkOnly"
                    [displayText]="cell.data.workOrderId"
                    (onLinkClick)="onWorkOrderCellClick(cell.data)"
                ></app-hyperlink-creator>
            </ng-container>
        </div>

        <div *dxTemplate="let cell of 'maintenanceJobTemplate'">
            <!-- INFO: Implementation JOB Management is dropped/delayed in V2 as decided by Sandeep -->
            <!-- <div class="cell-link-content">
                            <a href="javascript:void(0)" (click)="onMaintenanceJobClick(cell.data)">{{ cell.data.maintenanceJob }}</a>
                        </div> -->
            {{ cell.data.maintenanceJob }}
        </div>

        <div *dxTemplate="let row of 'taskListTemplate'">
            <div class="row-container">
                <ng-container *ngFor="let id of row.data.taskIds">
                    <div class="add-padding">
                        <app-hyperlink-creator
                            cssClass="cc-hyperlink-underline-hover"
                            [displayText]="id"
                            actionCode="PROJECTS_TASKS"
                            (onLinkClick)="onTaskIdClick(id, row.data)"
                        ></app-hyperlink-creator>
                    </div>
                </ng-container>
            </div>
        </div>

        <div *dxTemplate="let row of 'invoiceListTemplate'">
            <div class="row-container">
                <ng-container *ngFor="let id of row.data.invoiceIds">
                    <div class="add-padding">
                        <app-hyperlink-creator
                            cssClass="cc-hyperlink-underline-hover"
                            [displayText]="id"
                            actionCode="SEARCH_INVOICES"
                            (onLinkClick)="onInvoiceClick(id, row.data)"
                        ></app-hyperlink-creator>
                    </div>
                </ng-container>
            </div>
        </div>

        <div *dxTemplate="let r of 'createdByUserDisplayTemplate'" class="responsible-container">
            <ng-container
                [ngTemplateOutlet]="singleUserTemplate"
                [ngTemplateOutletContext]="{ data: r.data, user: r.data.createdBy }"
            ></ng-container>
        </div>

        <div *dxTemplate="let r of 'dashboardResponsibleUserTemplate'" class="responsible-container">
            <ng-container
                *ngIf="r.data.dashboardResponsible.length === 1"
                [ngTemplateOutlet]="singleUserTemplate"
                [ngTemplateOutletContext]="{ data: r.data, user: r.data.dashboardResponsible[0] }"
            ></ng-container>
            <ng-container
                *ngIf="r.data.dashboardResponsible.length > 1"
                [ngTemplateOutlet]="multiUsersTemplate"
                [ngTemplateOutletContext]="{
                    users: r.data.dashboardResponsible,
                    communityId: r.data.communityId,
                    title: 'Dashboard Resposible Users',
                    displayText: r.data.dashboardResponsibleUserDisplayText
                }"
            ></ng-container>
        </div>

        <div *dxTemplate="let r of 'primaryAcamUserDisplayTemplate'" class="responsible-container">
            <ng-container
                *ngIf="r.data.primaryAcam.length === 1"
                [ngTemplateOutlet]="singleUserTemplate"
                [ngTemplateOutletContext]="{ data: r.data, user: r.data.primaryAcam[0] }"
            ></ng-container>
            <ng-container
                *ngIf="r.data.primaryAcam.length > 1"
                [ngTemplateOutlet]="multiUsersTemplate"
                [ngTemplateOutletContext]="{
                    users: r.data.primaryAcam,
                    communityId: r.data.communityId,
                    title: 'Primary ACAM',
                    displayText: r.data.primaryAcamDisplayText
                }"
            ></ng-container>
        </div>

        <div *dxTemplate="let r of 'primaryCamUserDisplayTemplate'" class="responsible-container">
            <ng-container
                *ngIf="r.data.primaryCam.length === 1"
                [ngTemplateOutlet]="singleUserTemplate"
                [ngTemplateOutletContext]="{ data: r.data, user: r.data.primaryCam[0] }"
            ></ng-container>
            <ng-container
                *ngIf="r.data.primaryCam.length > 1"
                [ngTemplateOutlet]="multiUsersTemplate"
                [ngTemplateOutletContext]="{
                    users: r.data.primaryCam,
                    communityId: r.data.communityId,
                    title: 'Primary CAM',
                    displayText: r.data.primaryCamDisplayText
                }"
            ></ng-container>
        </div>

        <div *dxTemplate="let r of 'statusChangedByUserDisplayTemplate'" class="responsible-container">
            <ng-container
                [ngTemplateOutlet]="singleUserTemplate"
                [ngTemplateOutletContext]="{ data: r.data, user: r.data.statusChangedBy }"
            ></ng-container>
        </div>

        <div *dxTemplate="let r of 'responsibleUserDisplayTemplate'" class="responsible-container">
            <ng-container
                [ngTemplateOutlet]="singleUserTemplate"
                [ngTemplateOutletContext]="{ data: r.data, user: r.data.responsible }"
            ></ng-container>
        </div>

        <div *dxTemplate="let header of 'lockHeaderCellTemplate'">
            {{ header.column.caption }}
            <app-security-info securityIndicator="LOCK" apiAction="GET" apiUrl="api/workorder/open"></app-security-info>
        </div>

        <dxo-summary>
            <dxi-group-item
                column="workOrderId"
                summaryType="count"
                displayFormat="Count = {0}"
                [skipEmptyValues]="true"
            ></dxi-group-item>
        </dxo-summary>
    </dx-data-grid>
</cc-data-grid-features>

<ng-template #singleUserTemplate let-user="user" let-data="data">
    <div class="res-content">
        <app-user-bio-link [user]="user" [communityId]="data.communityId"></app-user-bio-link>
    </div>
</ng-template>

<ng-template
    #multiUsersTemplate
    let-users="users"
    let-communityId="communityId"
    let-title="title"
    let-displayText="displayText"
>
    <div class="res-content">
        <app-hyperlink-creator
            mode="hyperlinkOnly"
            [displayText]="displayText"
            (onLinkClick)="showUsersList({ users: users, communityId: communityId, title: title })"
        ></app-hyperlink-creator>
    </div>
</ng-template>

<app-multi-user-bio-links
    *ngIf="showUsersListPopup"
    [users]="selectedUserConfig.users"
    [communityId]="selectedUserConfig.communityId"
    [title]="selectedUserConfig.title"
    (onClose)="onUserListClose()"
></app-multi-user-bio-links>

<app-work-orders-notes-editor
    *ngIf="showNotes"
    [communityId]="selectedWorkOrder?.communityId"
    [workOrderId]="selectedWorkOrder?.workOrderId"
    (onClose)="onGridNotesClose($event)"
></app-work-orders-notes-editor>

<app-work-orders-history
    *ngIf="showHistory"
    [communityId]="selectedWorkOrder?.communityId"
    [workOrderId]="selectedWorkOrder?.workOrderId"
    (onClose)="onHistoryClose($event)"
></app-work-orders-history>

<app-manage-work-order-authorization
    *ngIf="showManageWorkAuthorization"
    [workOrderId]="selectedWorkOrder?.workOrderId"
    [communityId]="selectedWorkOrder?.communityId"
    [customerId]="selectedWorkOrder?.customerId"
    (onClose)="onManageWorkorderAuthorizationClose()"
    (onManageProposalShow)="onManageProposalShow()"
    (onWorkOrderEditorShow)="onWorkOrderEditorShow()"
></app-manage-work-order-authorization>

<app-manage-work-order-proposals
    *ngIf="showManageProposals"
    [workOrderId]="selectedWorkOrder?.workOrderId"
    [communityId]="selectedWorkOrder?.communityId"
    [customerId]="selectedWorkOrder?.customerId"
    (onClose)="onManageProposalClose()"
    (onWorkOrderEditorShow)="onWorkOrderEditorShow()"
    (onManageWorkAuthorizationShow)="onManageWorkAuthorizationShow()"
></app-manage-work-order-proposals>

<app-attachment-uploader
    *ngIf="showAttachments"
    title="Manage Documents"
    [isViewOnly]="!isInternalUser"
    [selectedAttachments]="workOrderAttachments"
    [communityId]="selectedWorkOrder?.communityId"
    [customerId]="selectedWorkOrder?.customerId"
    [communityApiUrl]="'api/workorder/community/documents/tree'"
    [communityDocuments]="communityDocuments"
    [ownerApiUrl]="'api/workorder/owner/documents/tree'"
    [ownerDocuments]="ownerDocuments"
    (onAttachmentUpdate)="onAttachmentUpdate($event)"
    (onDocumentDelete)="onAttachmentDelete($event)"
    (onClose)="onAttachmentUploaderClose()"
></app-attachment-uploader>

<app-workflow-viewer
    *ngIf="showWorkflowViewer"
    [viewOnly]="true"
    [workflowId]="selectedWorkflowId"
    [communityId]="selectedWorkOrder?.communityId"
    (onClose)="onWorkflowViewerClose()"
></app-workflow-viewer>

<app-work-order-manage-invoices
    *ngIf="showManageInvoices"
    [invoiceIds]="selectedWorkOrder?.invoiceIds"
    [workOrderId]="selectedWorkOrder?.workOrderId"
    [communityId]="selectedWorkOrder?.communityId"
    (onClose)="onManageInvoicesClose($event)"
></app-work-order-manage-invoices>

<app-work-order-manage-tasks
    *ngIf="showManageTask"
    [taskIds]="selectedWorkOrder?.taskIds"
    [workOrderId]="selectedWorkOrder?.workOrderId"
    [communityId]="selectedWorkOrder?.communityId"
    (onClose)="onManageTaskClose($event)"
></app-work-order-manage-tasks>

<app-project-task-viewer
    *ngIf="showTaskViewer"
    [taskId]="selectedTaskId"
    [communityId]="selectedWorkOrder?.communityId"
    [notesActionCode]="PROJECTS_TASKS"
    (onClose)="onWorkOrderTaskClose()"
></app-project-task-viewer>

<app-work-orders-editor
    *ngIf="showWorkOrderEditor"
    [workOrderId]="selectedWorkOrder?.workOrderId"
    [communityId]="selectedWorkOrder?.communityId"
    [customerId]="selectedWorkOrder?.customerId"
    (onClose)="onWorkOrderEditorClose($event)"
    (onManageProposalShow)="onManageProposalShow()"
    (onManageWorkAuthorizationShow)="onManageWorkAuthorizationShow()"
></app-work-orders-editor>

<cc-message-box #workOrderMessageBox></cc-message-box>
